import styles from './style.postcss';

import React, { PureComponent } from 'react';
import { SolidRadio } from 'omni-common-ui';
import Languages from 'domain/Languages';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import is from 'is_js';

class LanguageRadio extends PureComponent {
  render() {
    const {
      choosedLanguageCode,
      languageCode,
    } = this.props;
    return <div className={classnames(styles.LanguageRadio, this.props.className)}>
      {
        is.existy(this.props.title) &&
        <div>{this.props.title}</div>
      }
      <div>
        <SolidRadio name={this.props.name}
            id={`${this.props.name}-1`}
            value={languageCode}
            isChecked={choosedLanguageCode === languageCode}
            onChange={this.props.onChecked} />
        {Languages.getDisplayName(languageCode)}
      </div>
      {
        languageCode === 'id-ID' && <div>
          <SolidRadio name={this.props.name}
              id={`${this.props.name}-2`}
              value={'zh-CN'}
              isChecked={choosedLanguageCode === 'zh-CN'}
              onChange={this.props.onChecked} />
          {Languages.getDisplayName('zh-CN')}
        </div>
      }
      <div>
        <SolidRadio name={this.props.name}
            id={`${this.props.name}-3`}
            value={Languages.defaultLanguageCode}
            isChecked={choosedLanguageCode === Languages.defaultLanguageCode}
            onChange={this.props.onChecked} />
        {Languages.getDisplayName(Languages.defaultLanguageCode)}
      </div>
    </div>;
  }
}

LanguageRadio.propTypes = {
  title: PropTypes.string,
  languageCode: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChecked: PropTypes.func.isRequired,
  choosedLanguageCode: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default LanguageRadio;



// WEBPACK FOOTER //
// ./components/LanguageRadio/index.jsx